import { format } from 'date-fns';
import { InlineStartBillingMenuItem } from "../../../../../components/ServiceDetails/BillingSettingsSection/InlineStartBillingControl/InlineStartBillingControl";
import { getStartBillingSelection } from "../../../../../components/ServiceDetails/BillingSettingsSection/InlineStartBillingControl/InlineStartBillingControl.utils";
import { serviceBillingModel, serviceCostModel, serviceModel } from "../../../../../models";
import { autoBillingPeriodLabel } from "../../../../../utils/service-billing/automatic-service-billing-period";
function getStartBillingText(service) {
  const selection = getStartBillingSelection(service);
  switch (selection) {
    case InlineStartBillingMenuItem.NextBillingDay:
      return 'starting on the next scheduled billing date';
    case InlineStartBillingMenuItem.SpecificDate:
      {
        const date = serviceModel.startBillingAt(service);
        return date ? "starting on ".concat(format(date, 'MMM d, yyyy')) : 'starting on the next scheduled billing date';
      }
    case InlineStartBillingMenuItem.AcceptanceDate:
      return 'starting on proposal acceptance';
    case InlineStartBillingMenuItem.Today:
      return 'starting today';
    case InlineStartBillingMenuItem.ManualInitiation:
      return 'only after manual initiation';
  }
}
function getUpfrontText(service) {
  const isBilledUpfront = serviceBillingModel.isBilledUpfront(service.billing);
  const isQuarterly = serviceBillingModel.isQuarterly(service.billing);
  if (isQuarterly) {
    return isBilledUpfront ? 'upfront on the 1st day of every quarter' : 'on the last day of every quarter';
  }
  return isBilledUpfront ? 'upfront' : 'at the end of the billing cycle';
}
export function getSubtitle(service) {
  if (!serviceBillingModel.isAutomatic(service.billing)) {
    return serviceCostModel.stringifyServiceCost(service.cost).unitCapDisplay;
  }
  const periodLabel = autoBillingPeriodLabel(service.billing);
  if (!periodLabel) return undefined;
  const upfrontText = getUpfrontText(service);
  const startBillingText = getStartBillingText(service);
  return "Billed ".concat(upfrontText, " ").concat(periodLabel.text.replace('Billed ', '').replace('Billed', ''), ", ").concat(startBillingText);
}